const styles = () => ({
  notification: {
    '&:first-of-type': {
      borderTopLeftRadius: 7,
      borderTopRightRadius: 7,
    },

    '&:last-of-type': {
      borderBottom: '1px solid #fde08e',
      borderBottomLeftRadius: 7,
      borderBottomRightRadius: 7,
    },
  },
});

export default styles;
